<template>

    <div>
        <p v-if="single.id">
            <span class="label">Editing effort log #{{single.id}}</span>
        </p>

        <div class="mb-3">
            <label class="control-label">Time Spent (hrs)</label>
            <input-mask placeholder="HH:MM" class="form-control" v-model="stateSpent" mask="99:99" maskChar=""></input-mask>
        </div>

        <div class="mb-3">
            <label class="control-label">Start:</label>
            <datepicker v-model="stateEntryDate" input-class="form-control"></datepicker>
        </div><!-- /.form-group -->

        <div class="mb-3">
            <label class="control-label">Notes</label>
            <input type="text" v-model="stateReference" class="form-control">
        </div>

        <div class="mb-3">
            <label class="control-label">User</label>
            <user-select :user="stateUser" :userChanged="userSelected" :inline="true"></user-select>
        </div>

        <div class="text-end">
            <button type="button" @click="close()" class="btn btn-rounded btn-light me-1">Cancel</button>
            <c-button type="button" @click="save" class="btn btn-rounded btn-primary">Log Effort</c-button>
        </div>
    </div>

</template>

<script>

    import InputMask from 'vue-input-mask'
    import Datepicker from 'vuejs-datepicker'
    import Multiselect from 'vue-multiselect'
    import effortStateMapper from '@/mixins/scrumboard/effort-state-mapper'
    import moment from 'moment'
    import { filter, cloneDeep } from 'lodash'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'
    import { LaddaButton } from 'components/form/input'

    export default {
        mixins: [effortStateMapper],
        props: {
            propItem: Object,
            propLogId: Number,
            close: Function,
        },
        components: {
            Multiselect,
            UserSelect,
            Datepicker,
            InputMask,
            LaddaButton
        },

        computed: {
            ...mapGetters('user', ['authorizedSelect']),
            ...mapState('yodizproject/effort', ['single']),
        },

        mounted: function() {
          this.resetEffortLog()

          this.assignUser()
          this.stateEntryDate = new Date()
        },

        methods: {
            ...mapActions('yodizproject/effort', {
                addEffortLog: 'addListObject',
                updateEffortLog: 'updateListObject',
                resetEffortLog: 'resetSingle'
            }),

            ...mapActions('yodizproject/stories', {
                setStoryListProperty: 'setSingleListProperty'
            }),

            ...mapActions('yodizproject/tasks', {
                setTaskListProperty: 'setSingleListProperty'
            }),

            assignUser() {
              if (!this.single.id) {
                this.stateUser = cloneDeep(this.authorizedSelect)
              }
            },

            async save() {
                this.stateEntryDate = moment(this.single.entry_date).format('YYYY-MM-DD')

                if (this.single.id) {
                    //Server returns decimal version, we conver to masked string in the statemapper
                    //if the user hasn't chaned the time then the decimal will try to be sent,
                    //server expects formatted string 00:00
                    if (!isNaN(this.single.spent)) {
                        this.stateSpent = this.stateSpent
                    }

                    let response = await this.updateEffortLog({id: this.single.id, payload: Object.assign(this.single, {'item_id': this.propItem.id})})

                    //The API should return story and task partials so we don't have to make multiple requests
                    if (response.data) {
                        if (response.data.hasOwnProperty('story')) {
                            this.setStoryListProperty({ id: response.data.story.id, property: 'time_entries_total', value: response.data.story.time_entries_total })
                        }

                        if (response.data.hasOwnProperty('item')) {
                            this.setTaskListProperty({ id: response.data.item.id, property: 'time_entries_total', value: response.data.item.time_entries_total })
                        }
                    }

                } else {
                    let response = await this.addEffortLog({payload: Object.assign(this.single, {'item_id': this.propItem.id})})

                    //The API should return story and task partials so we don't have to make multiple requests
                    if (response.data) {
                        if (response.data.hasOwnProperty('story')) {
                            this.setStoryListProperty({ id: response.data.story.id, property: 'time_entries_total', value: response.data.story.time_entries_total })
                        }

                        if (response.data.hasOwnProperty('item')) {
                            this.setTaskListProperty({ id: response.data.item.id, property: 'time_entries_total', value: response.data.item.time_entries_total })
                        }
                    }
                }

                this.resetEffortLog()
                this.assignUser()
            },

            userSelected(user) {
                this.stateUser = user
                this.stateUserId = user.id
            }
        }
    }
</script>
